const MIN_VIDEO_WIDTH = 720;
const MIN_VIDEO_RESOLUTION = 720 * 1280;

const videoCheckMixin = {
  data: () => ({
  }),
  methods: {
    async isResolutionEnough(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          resolve(false);
        }

        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);

        // have some trouble with proprietary video formats
        video.onerror = () => {
          reject(new Error(video.error.message));
        };

        video.onloadedmetadata = () => {
          const isVideoWidthOk = video.videoWidth >= MIN_VIDEO_WIDTH;
          const isVideoResolutionOk = video.videoWidth * video.videoHeight >= MIN_VIDEO_RESOLUTION;

          URL.revokeObjectURL(video.src);
          if (isVideoWidthOk && isVideoResolutionOk) {
            resolve(true);
          }

          resolve(false);
        };
      });
    },
    // async isVideoCanBePreprocessed(video) {
    //   return new Promise((resolve) => {
    //     video.onerror = () => {
    //       console.log(`Error ${video.error.code}; details: ${video.error.message}`);
    //     };
    //   });
    // },
  },
};

export default videoCheckMixin;
